const i18n = window.I18n

export const getLocale = (): string => i18n.locale;

export const localeFromPathname = (): string => {
  const { pathname } = document.location;
  return (pathname[0] === "/" && pathname[3] === "/") ? pathname.slice(1, 3) : "en";
}

export const setLocale = (locale: string): void => {
  i18n.locale = locale
}

export const t = (key?: string | null, options?: I18n.TranslateOptions): string => {
  return key ? i18n.t(key, options) : ""
}
